import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbModalRef, NgbModalOptions, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { NgxSpinnerService } from "ngx-spinner";
import { FormBuilder, FormGroup, Validators, FormControl } from "@angular/forms";
import Swal from "sweetalert2";
import { ActivatedRoute, Router } from '@angular/router';
import { ReportedAnswereService } from "../reported-answere.service";
@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit {

  closeResult: string;
  userDetails: object;
  statusFormSubmitted: boolean = false;
  resetPasswordFormSubmitted: boolean = false;

  statusForm: FormGroup;
  formSubmitted: boolean = false;
  // reportQuestionList = [{ question: "Question 1", creationDate: 1570609584 }, { question: "Question 2", creationDate: 1570609584 }, { question: "Question 3", creationDate: 1570609582 }, { question: "Question 4", creationDate: 1570609523 }, { question: "Question 5", creationDate: 1570609524 }];
  NotificationForm: FormGroup;
  private modalRef: NgbModalRef;

  "questionList" = []
  modelOptions: NgbModalOptions = {
    backdrop: "static",
    keyboard: false,
    size:"sm"
  };

  searchText: string = "";
  constructor(
    private modalService: NgbModal,
    private ReportedAnswereService: ReportedAnswereService,
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private router: Router, private route: ActivatedRoute
  ) { }
  ngOnInit() {
    this.questionList;
    this.getreportList();
  }
  getreportList() {

    this.spinner.show();
    this.ReportedAnswereService.GetReportedUser().subscribe(res => {
      if (res["message"] = "Success") {
        this.questionList = res.data.reportedUserList;
        this.spinner.hide();
      } else {
        this.questionList = [];
        this.spinner.hide();
      }
    });
  }
  sendNotification(row, content, btn) {

    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();
    this.userDetails = row;
    this.formSubmitted = false;
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  clearReport(data) {
    this.spinner.show();
    this.ReportedAnswereService.clearReportedUsers('').subscribe(res => {
      if ((res["message"] == "Success")) {
        this.getreportList();
        this.modalRef.close();
        Swal.fire("Success", "Reported User Clear successfully!", "success");
        this.spinner.hide();
      } else {
        Swal.fire({
          type: "error",
          title: "Error",
          text: res.msg
        });

      }
    });
  }

  navigateReportDetail(row) {
    this.router.navigate(['main/report/report-detail/', row._id], { queryParams: { question: row.answerText }, preserveQueryParams: false });

  }
  reportAnswere(id, status) {

    let requestObj = {
      isReported: status,
      answerId: id
    }
    // this.spinner.show();


    this.ReportedAnswereService.reportedAnswere(requestObj).subscribe(data => {
      if (data["message"] == "Success") {

        Swal.fire("Success", "Answere Reported Successfully!", "success");
      } else {
        Swal.fire({
          type: "error",
          title: "Error",
          text: data.msg
        });
      }
    });
  }


  prepareUpdateStatusForm() {
    this.statusForm = this.formBuilder.group({
      newStatus: ["", [Validators.required]]
    });
  }
  updateUserStatusModal(row, content, btn) {
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();
    this.userDetails = row;
    this.statusFormSubmitted = false;
    this.prepareUpdateStatusForm();
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  deleteRecord(record: any) {

    this.spinner.show();
    let query = {
      userId:this.userId,
      status:''
    };
    if(record == 'delete'){
     query['status'] = 'deleted'
    }
    else if(record == 'suspend'){
      query['status'] = 'suspended'
    }
    
    this.ReportedAnswereService.updateUserStatus(query).subscribe(res => {
      if ((res["status"] = "Success")) {
        if(record == 'delete'){
          Swal.fire("Success", "User Deleted successfully!", "success");
         }
         else if(record == 'suspend'){
          Swal.fire("Success", "User Suspended successfully!", "success");
         }
        
        this.closeModal();
        this.getreportList();
        this.spinner.hide();
        
      } else {
        Swal.fire({
          type: "error",
          title: "Error",
          text: res.msg
        });

      }
    });
    this.spinner.hide();

  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  updateUserStatus(test) {
    this.statusFormSubmitted = true;
    if (this.statusForm.valid) {
      this.spinner.show();
      let finalObj = {
        userId: this.userDetails["userId"],
        status: this.statusForm.controls.newStatus.value
      };

      this.ReportedAnswereService.updateUserStatus(finalObj).subscribe(data => {
        this.spinner.hide();

        if ((data["message"] = "Success")) {
          Swal.fire("Success", "User status updated successfully!", "success");
          this.closeModal();
        } else {
          Swal.fire({
            type: "error",
            title: "Error",
            text: data.msg
          });
        }
      });
    }
    this.spinner.hide();
  }
userId:any
  updateUserStatusEdit(row, content, btn) {
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();
    this.userDetails = row;
    this.statusFormSubmitted = false;
    this.prepareUpdateStatusForm();
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.isModalOpen = true;
    this.modalRef.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  isModalOpen:boolean = false;
  statusList:any
  closeModal(){
    this.modalRef.close()
    this.isModalOpen=false;
  }

  deleteStatusModal(row, content, btn) {
    this.userId = row.reportedUserId;
    
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();

    this.userDetails = row;
    this.statusFormSubmitted = false;
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.isModalOpen = true;
    this.modalRef.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

}
